import { faker } from '@faker-js/faker';
import { cleanup } from '@testing-library/react';
import { HttpResponse, http } from 'msw';
import { setupServer } from 'msw/node';

import constants from '../constants';
import redux from '../redux';
import translations from '../translations';

translations.init();

describe('customer group selector reading the current context', () => {
  // create a mock server
  const server = setupServer(
    http.get(constants.endpoints.get.context, () => {
      return HttpResponse.json({
        customer_group_uuid: faker.string.uuid(),
        customer_uuid: faker.string.uuid(),
        enforce: 'customer_group',
        partner_uuid: faker.string.uuid(),
      });
    }),
  );

  beforeAll(() => {
    server.listen();
  });

  afterAll(() => {
    server.close();
  });

  afterEach(() => {
    server.resetHandlers();
    cleanup();
  });

  it('should read the current context', async () => {
    redux.store.dispatch(redux.api.getContext());

    await new Promise((resolve) => {
      setTimeout(resolve, 100);
    });

    expect(redux.store.getState().api.context).not.toBeUndefined();
    expect(redux.store.getState().api.context).not.toBeNull();
  });
});
